import axios from 'axios';

const DefaultPageSize = 10;

export default {
  /**
   * Get activity audit feed for a event
   *
   */
  getByEventId(
    teamId,
    eventId,
    pageNumber,
    pageSize,
    userIds,
    showIds,
    startDate,
  ) {
    return axios
      .post('/api/activityAudit.getByEventId', {
        query: {
          page: pageNumber,
          size: pageSize || DefaultPageSize,
          userIds,
          showIds,
          startDate,
        },
        params: {
          teamId,
          eventId,
        },
      })
      .then((result) => result.data);
  },

  /**
   * Get activity audit feed for a show
   *
   */
  getByShowId(teamId, eventId, showId, pageNumber, pageSize) {
    return axios
      .post('/api/activityAudit.getByShowId', {
        query: {
          page: pageNumber,
          size: pageSize || DefaultPageSize,
        },
        params: {
          teamId,
          eventId,
          showId,
        },
      })
      .then((result) => result.data);
  },

  /**
   * Get activity audit feed for an item field (i.e. title or description)
   *
   */
  getByItemField(
    teamId,
    eventId,
    showId,
    itemId,
    fieldName,
    pageNumber,
    pageSize,
  ) {
    return axios
      .post('/api/activityAudit.getByItemField', {
        query: {
          page: pageNumber,
          size: pageSize || DefaultPageSize,
        },
        params: {
          teamId,
          eventId,
          showId,
          itemId,
          fieldName,
        },
      })
      .then((result) => result.data);
  },

  /**
   * Get activity audit feed for an item cell
   *
   */
  getByItemCell(
    teamId,
    eventId,
    showId,
    itemId,
    columnId,
    pageNumber,
    pageSize,
  ) {
    return axios
      .post('/api/activityAudit.getByItemCell', {
        query: {
          page: pageNumber,
          size: pageSize || DefaultPageSize,
        },
        params: {
          teamId,
          eventId,
          showId,
          itemId,
          columnId,
        },
      })
      .then((result) => result.data);
  },

  /**
   * Get activity audit feed for an specific method
   *
   */
  getByMethodName(teamId, eventId, showId, methodName, pageNumber, pageSize) {
    return axios
      .post('/api/activityAudit.getByMethodName', {
        query: {
          page: pageNumber,
          size: pageSize || DefaultPageSize,
        },
        params: {
          teamId,
          eventId,
          showId,
          methodName,
        },
      })
      .then((result) => result.data);
  },

  /**
   * Get activity audit feed for all deleted rows
   *
   */
  getSoftDeletedItemRows(
    teamId,
    eventId,
    showId,
    itemSetId,
    pageNumber,
    pageSize,
  ) {
    return axios
      .post('/api/activityAudit.getSoftDeletedItemRows', {
        query: {
          page: pageNumber,
          size: pageSize || DefaultPageSize,
        },
        params: {
          teamId,
          eventId,
          showId,
          itemSetId,
        },
      })
      .then((result) => result.data);
  },

  /**
   * Get activity audit feed for all deleted rows
   *
   */
  getSoftDeletedColumns(
    teamId,
    eventId,
    showId,
    itemSetListId,
    pageNumber,
    pageSize,
  ) {
    return axios
      .post('/api/activityAudit.getSoftDeletedColumns', {
        query: {
          page: pageNumber,
          size: pageSize || DefaultPageSize,
        },
        params: {
          teamId,
          eventId,
          showId,
          itemSetListId,
        },
      })
      .then((result) => result.data);
  },
};
